import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast, Slide } from 'react-toastify';
import ProjectDetail from '../common/ProjectDetail';
import { postRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import './Opportunity.scss';
import '../common/LikeDislikeProject/LikeDislikeProject.scss';

const toastMessage = () => (
  <div className="body-text-2 g-row--always">
    <i className="fas fa-check-circle me-3" />
    <span className="d-none d-sm-block">
      Got it! We&#39;ll use this info to make better project recommendations.
    </span>
    <span className="d-block d-sm-none body-text-3">We’ll use this to make better recommendations.</span>
  </div>
);

class Opportunity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovering: false,
      isHoveringOverLike: false,
      isHoveringOverDislike: false,
      showDetails: false,
      showReferralModal: false,
      notify: props.notify,
      liked: props.liked,
      disliked: props.disliked,
    };
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseOverLike = this.handleMouseOverLike.bind(this);
    this.handleMouseLeaveLike = this.handleMouseLeaveLike.bind(this);
    this.handleMouseOverDislike = this.handleMouseOverDislike.bind(this);
    this.handleMouseLeaveDislike = this.handleMouseLeaveDislike.bind(this);
    this.openDetails = this.openDetails.bind(this);
    this.closeDetails = this.closeDetails.bind(this);
    this.openReferralModal = this.openReferralModal.bind(this);
    this.closeReferralModal = this.closeReferralModal.bind(this);
    this.toggleNotification = this.toggleNotification.bind(this);
    this.handleProjectRedirect = this.handleProjectRedirect.bind(this);
    this.like = this.like.bind(this);
    this.dislike = this.dislike.bind(this);
  }

  handleMouseOver() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    this.setState({ isHovering: false });
  }

  handleMouseOverLike() {
    this.setState({ isHoveringOverLike: true, isHoveringOverDislike: false });
  }

  handleMouseLeaveLike() {
    this.setState({ isHoveringOverLike: false });
  }

  handleMouseOverDislike() {
    this.setState({ isHoveringOverLike: false, isHoveringOverDislike: true });
  }

  handleMouseLeaveDislike() {
    this.setState({ isHoveringOverDislike: false });
  }

  handleProjectRedirect() {
    const { projectUrl } = this.props;
    window.location.href = projectUrl;
  }

  openDetails() {
    const { id, name } = this.props;
    this.setState({ showDetails: true, showReferralModal: false });
    analyticsTrack('Opened up an Opportunity Modal', {
      location: 'Opportunities Index View',
      id,
      project_name: name,
    });
  }

  closeDetails() {
    this.setState({ showDetails: false });
  }

  openReferralModal() {
    this.setState({ showReferralModal: true, showDetails: false });
  }

  closeReferralModal() {
    this.setState({ showReferralModal: false });
  }

  toggleNotification() {
    const { id, csrfToken, toggleNotificationUrl } = this.props;
    const { notify } = this.state;
    return postRequest(
      toggleNotificationUrl,
      {
        project_id: id,
      },
      csrfToken,
    ).then(() => {
      this.setState({ notify: !notify });
    });
  }

  like() {
    const {
      id, name, likePath, csrfToken,
    } = this.props;
    return postRequest(
      likePath,
      {
        project_id: id,
      },
      csrfToken,
    ).then(() => {
      analyticsTrack('Liked an Opportunity', {
        location: 'Opportunities Index View',
        id,
        project_name: name,
      });
      this.setState({ liked: true, disliked: false });
      toast.success(toastMessage);
    });
  }

  dislike() {
    const {
      id, name, dislikePath, csrfToken,
    } = this.props;
    return postRequest(
      dislikePath,
      {
        project_id: id,
      },
      csrfToken,
    ).then(() => {
      analyticsTrack('Disliked an Opportunity', {
        location: 'Opportunities Index View',
        id,
        project_name: name,
      });
      this.setState({ liked: false, disliked: true });
      toast.success(toastMessage);
    });
  }

  render() {
    const {
      id,
      name,
      workCommitment,
      areaOfExpertises,
      tags,
      duration,
      workLocation,
      isUpcoming,
      projectInvitationStatus,
      levels,
      employmentType,
      showProjectEmploymentType,
      basePayHidden,
      budgetMinimum,
      budgetMaximum,
    } = this.props;
    const {
      isHovering, notify, liked, disliked,
      isHoveringOverLike, isHoveringOverDislike,
    } = this.state;

    return ([
      <div
        className="opportunity"
        role="button"
        tabIndex={0}
        key={id}
      >
        <ToastContainer
          position="top-center"
          transition={Slide}
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
        />
        <div className="details">
          <div
            role="button"
            tabIndex={0}
            className="details-hover-window"
            onMouseOver={this.handleMouseOver}
            onFocus={this.handleMouseOver}
            onMouseLeave={this.handleMouseLeave}
            onClick={this.handleProjectRedirect}
          >
            {isUpcoming
              && (
              <div>
                <i
                  className={`notification pull-right fa${notify ? 's' : 'r'} fa-bell`}
                  onClick={() => this.toggleNotification()}
                  role="button"
                  tabIndex={0}
                />
              </div>
              )}
            <div
              className="info"
              onClick={isUpcoming ? this.openDetails : undefined}
              role="button"
              tabIndex={0}
            >
              <ProjectDetail
                key={`project-${id}`}
                name={name}
                workCommitment={workCommitment}
                tags={areaOfExpertises.concat(tags)}
                duration={duration}
                workLocation={workLocation}
                projectInvitationStatus={projectInvitationStatus}
                levels={levels}
                employmentType={employmentType}
                showProjectEmploymentType={showProjectEmploymentType}
                basePayHidden={basePayHidden}
                budgetMinimum={budgetMinimum}
                budgetMaximum={budgetMaximum}
              />
            </div>
          </div>

          <div className="like-dislike">
            <div className="d-none d-sm-block">
              Would you like to see more projects like this one?
            </div>
            <div className="d-block d-sm-none body-text-3">
              Want to see more projects like this?
            </div>
            <i
              className={`ms-2 fa${(liked || isHoveringOverLike) ? 's' : 'r'} fa-thumbs-up fa-flip-horizontal`}
              onMouseOver={this.handleMouseOverLike}
              onFocus={this.handleMouseOverLike}
              onMouseLeave={this.handleMouseLeaveLike}
              onClick={() => this.like()}
              role="button"
              tabIndex={0}
            />
            <i
              className={`ms-2 fa${(disliked || isHoveringOverDislike) ? 's' : 'r'} fa-thumbs-down`}
              onMouseOver={this.handleMouseOverDislike}
              onFocus={this.handleMouseOverDislike}
              onMouseLeave={this.handleMouseLeaveDislike}
              onClick={() => this.dislike()}
              role="button"
              tabIndex={0}
            />
          </div>

          <div
            /* Only add margins to "View More" button if on Upcoming Opportunities tab */
            className={`actions my-2 ${isUpcoming ? ' mt-3' : ''}`}
            onMouseOver={this.handleMouseOver}
            onFocus={this.handleMouseOver}
            onMouseLeave={this.handleMouseLeave}
          >
            {isHovering
              && (
              <span
                onClick={this.handleProjectRedirect}
                role="button"
                tabIndex={0}
                className="highlight-text float-end body-text-3 medium-weight d-none d-sm-block"
              >
                VIEW MORE
              </span>
              )}
            <span
              onClick={this.handleProjectRedirect}
              role="button"
              tabIndex={0}
              className="highlight-text float-end body-text-3 medium-weight d-block d-sm-none"
            >
              VIEW MORE
            </span>
          </div>
        </div>
      </div>,
    ]);
  }
}

Opportunity.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  workCommitment: PropTypes.number.isRequired,
  duration: PropTypes.string.isRequired,
  workLocation: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
  areaOfExpertises: PropTypes.arrayOf(PropTypes.string),
  levels: PropTypes.arrayOf(PropTypes.string),
  projectUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  likePath: PropTypes.string.isRequired,
  dislikePath: PropTypes.string.isRequired,
  isUpcoming: PropTypes.bool,
  notify: PropTypes.bool,
  toggleNotificationUrl: PropTypes.string,
  projectInvitationStatus: PropTypes.string,
  liked: PropTypes.bool,
  disliked: PropTypes.bool,
  employmentType: PropTypes.string.isRequired,
  showProjectEmploymentType: PropTypes.bool,
  basePayHidden: PropTypes.bool,
  budgetMinimum: PropTypes.string,
  budgetMaximum: PropTypes.string,
};

Opportunity.defaultProps = {
  areaOfExpertises: [],
  tags: [],
  isUpcoming: false,
  notify: false,
  toggleNotificationUrl: null,
  projectInvitationStatus: '',
  liked: false,
  disliked: false,
  showProjectEmploymentType: false,
  basePayHidden: false,
  budgetMinimum: '',
  budgetMaximum: '',

};

export default Opportunity;
